/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_content_delivery_bucket": "bomdata-20191007203549-hostingbucket-master",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://d2h0pdpvldshil.cloudfront.net",
    "aws_cognito_identity_pool_id": "us-east-1:183fd527-c8f8-41a4-93a8-16f972c64b76",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_EDUvbEPgF",
    "aws_user_pools_web_client_id": "288o71m76kao5dmfitikgc5hqk",
    "oauth": {
        "domain": "bomdata-master.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:19006/,https://app.bomdata.io/",
        "redirectSignOut": "http://localhost:19006/,https://app.bomdata.io/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_AND_IDENTITY_POOLS",
    "aws_appsync_graphqlEndpoint": "https://c6kls4j5cvbjjj675qzhdowht4.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cloud_logic_custom": [
        {
            "name": "StripeWebhook",
            "endpoint": "https://r2j6mddqrh.execute-api.us-east-1.amazonaws.com/master",
            "region": "us-east-1"
        },
        {
            "name": "Images",
            "endpoint": "https://sywnzmhy6i.execute-api.us-east-1.amazonaws.com/master",
            "region": "us-east-1"
        }
    ],
    "aws_user_files_s3_bucket": "bomdata-images-master",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
